import { createFileRoute, retainSearchParams } from "@tanstack/react-router";

import { WorldSessionLeaf } from "../components/WorldSessionView";

function WorldSessionRouteView() {
  const { sessionId } = Route.useParams();
  const { a } = Route.useSearch();
  return <WorldSessionLeaf addressSessionId={a} sessionId={sessionId} />;
}

export const Route = createFileRoute("/_chat/session/$sessionId")({
  component: WorldSessionRouteView,
  // World is the room's routing identity. Retain it through every session
  // navigation, including callers that clear the ancestor with search: {}.
  // The ancestor itself remains explicit view state and is never retained.
  search: { middlewares: [retainSearchParams<{ world?: string }>(["world"])] },
  // `?a=` names the ADDRESSED session (view state; RAIL-5b). Validation to
  // the leaf's lineage happens against the ready room index, not here.
  validateSearch: (
    search: Record<string, unknown>,
  ): { a?: string; world?: string; notice?: string } => ({
    ...(typeof search["a"] === "string" && search["a"].length > 0 ? { a: search["a"] } : {}),
    ...(typeof search["world"] === "string" && search["world"].length > 0
      ? { world: search["world"] }
      : {}),
    ...(typeof search["notice"] === "string" && search["notice"].length <= 256
      ? { notice: search["notice"] }
      : {}),
  }),
});
